import { DefaultTheme } from 'styled-components';
import {darken, lighten, rgba} from "polished";
import palette from "./palette";

const darkTheme: DefaultTheme = {
    colors: {
        bg: "black",
        fg: palette.clouds,
        primaryBg: palette.belizeHole,
        primaryFg: palette.clouds,
        secondaryBg: palette.wetAsphalt,
        secondaryFg: palette.silver,
        cardBg: palette.midnightBlue,
        cardFg: palette.clouds,
        mutedBg: palette.wetAsphalt,
        mutedFg: palette.asbestos,
        hover: (baseColor: string) => darken(.1, baseColor),
        even: (baseColor: string) => darken(.015, baseColor),
    },

    dashboard: {
        headerTextColor: palette.concrete,
    },

    accents: {
        default: {
            bg: palette.midnightBlue,
            fg: palette.clouds,
        },

        primary: {
            primaryBg: palette.belizeHole,
            primaryFg: palette.clouds,
            cardBg: palette.belizeHole,
            cardFg: palette.clouds,
        },

        muted: {
            primaryBg: "rgba(255, 255, 255, .12)",
            primaryFg: rgba(palette.clouds, .8),
            cardFg: rgba(palette.clouds, .6),
            cardBg: rgba(palette.midnightBlue, .5),
        },

        info: {
            primaryBg: palette.midnightBlue,
            primaryFg: palette.clouds,
            cardBg: palette.clouds,
            cardFg: palette.midnightBlue,
        },

        danger: {
            primaryBg: palette.alizarin,
            primaryFg: lighten(.5, palette.alizarin),
            cardBg: lighten(.5, palette.alizarin),
            cardFg: palette.alizarin,
        },

        success: {
            primaryBg: darken(.1, palette.nephritis),
            primaryFg: lighten(.5, palette.nephritis),
            cardBg: lighten(.5, palette.nephritis),
            cardFg: darken(.1, palette.nephritis)
        },

        warning: {
            primaryBg: palette.orange,
            primaryFg: lighten(.45, palette.orange),
            cardBg: lighten(.45, palette.orange),
            cardFg: palette.orange,
        }
    },

    bodyClass: "dark",
};

export default darkTheme;
